import React from 'react';
import cx from 'classnames';

import UnderlinedText from '@marketing/components/underlined_text';

import OfficialQuestionsScreen from './assets/official_questions_screen.png';
import marketingStyles from '@marketing/style.module.scss';
import styles from './style.module.scss';

export default (props) => {
  return (
    <div
      className={marketingStyles.purpleNoiseBg}
      style={{
        borderRadius: 20,
        boxShadow: '0 6px 6px -3px rgba(0, 0, 0, 0.07), 0 2px 2px -1px rgba(0, 0, 0, 0.07)',
        overflow: 'hidden'
      }}
    >
      <div className="d-flex flex-column flex-lg-row">
        <div className="align-items-center align-items-lg-start d-flex flex-column gap-l u-padding-A-xl">
          <div>
            <h2
              className={cx(styles.centeredOnMobile, 'u-margin-A-n')}
              style={{ color: '#FCB913', fontSize: 40 }}
            >
              <strong>Built With Official ACT<span className={styles.registeredMark}>®</span> Questions</strong>
            </h2>

            <h2
              className={cx(styles.centeredOnMobile, 'u-margin-A-n')}
              style={{ color: '#FFFFFF', fontSize: 40 }}
            >
              <strong>with Magoosh</strong>
            </h2>
          </div>

          <div className={styles.centeredOnMobile} style={{ color: '#FFFFFF', fontSize: 15 }}>
            Our self-paced ACT® prep course includes over{' '}
            <UnderlinedText color="#ffffff" flip>3,800 ACT® practice questions</UnderlinedText>{' '}
            used under license from the makers of the test, so you know you're studying exactly what you'll see on test day.
          </div>
        </div>

        <div
          className={cx(styles.officialQuestionsScreenContainer, 'd-flex align-items-end')}
          style={{ position: 'relative' }}
        >
          <img
            alt="Screenshot of official questions in Magoosh"
            className={styles.officialQuestionsScreen}
            loading="lazy"
            src={OfficialQuestionsScreen}
          />
        </div>
      </div>
    </div>
  );
};
